import React from 'react';

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning';
  size?: 'sm' | 'md' | 'lg';
}

const badgeVariants = {
  variant: {
    default: 'bg-brand-100 text-brand-800',
    secondary: 'bg-gray-100 text-gray-800',
    destructive: 'bg-red-100 text-red-800',
    outline: 'border border-gray-300 bg-white text-gray-700',
    success: 'bg-green-100 text-green-800',
    warning: 'bg-yellow-100 text-yellow-800'
  },
  size: {
    sm: 'px-2 py-1 text-sm',
    md: 'px-2.5 py-1.5 text-base',
    lg: 'px-3 py-2 text-lg'
  }
};

export const Badge: React.FC<BadgeProps> = ({
  className = '',
  variant = 'default',
  size = 'sm',
  children,
  ...props
}) => {
  const baseClasses = 'inline-flex items-center rounded-full font-medium transition-colors';
  const variantClasses = badgeVariants.variant[variant];
  const sizeClasses = badgeVariants.size[size];

  return (
    <div
      className={`${baseClasses} ${variantClasses} ${sizeClasses} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Badge;
